export function getVariantExistingStyle(variantId: string, renderingId: string) {
  if (typeof document === 'undefined') {
    return null
  }

  return document.querySelector(
    `.static-variant-visible-style[data-variant-id="${variantId}"][data-rendering-id="${renderingId}"]`,
  )
}
